import React from "react";
import { Link, useLocation, Navigate } from "react-router-dom";
import Header from "./header";
import Footer from "./Footer";
import moment from "moment";

export default function Welcome() {
  const location = useLocation();

  const user = location.state?.user;

  // Prevent opening welcome page directly without registration data
  if (!user) {
    return <Navigate to="/register" replace />;
  }

  const name = user?.name || "TEST";

  const userId =
    user?.userId ||
    user?.uniqueId ||
    user?.memberId ||
    user?._id ||
    "GI753740";

  const referralCode =
    user?.referralCode ||
    "TST484052";

  const formatLoginDate = (date) => {
    if (!date) return "-";

    return moment.utc(date).format("DD/MM/YYYY");
  };

  return (
    <>
      <Header />

      <div className="welcome-page">
        <div className="welcome-container">

          <h1 className="welcome-title">
            Welcome To <br />
            Global Innovation
          </h1>

          <div className="welcome-details">

            <div className="welcome-detail-row">
              <span className="welcome-detail-label">
                Name:
              </span>

              <span className="welcome-detail-value">
                {user?.name}
              </span>
            </div>

            <div className="welcome-detail-row">
              <span className="welcome-detail-label">
                User ID:
              </span>

              <span className="welcome-detail-value">
                {user?.userId}
              </span>
            </div>

            <div className="welcome-detail-row">
              <span className="welcome-detail-label">
                Login Date:
              </span>

              <span className="welcome-detail-value">
                {formatLoginDate(user.loginDate)}
              </span>
            </div>

            <div className="welcome-detail-row">
              <span className="welcome-detail-label">
                Email:
              </span>

              <span className="welcome-detail-value">
                {user?.email}
              </span>
            </div>

            <div className="welcome-detail-row">
              <span className="welcome-detail-label">
                Referral User ID:
              </span>

              <span className="welcome-detail-value">
                {user?.referralCode}
              </span>
            </div>

          </div>

          <div className="welcome-screenshot-message">
            Please Take A Screenshot Of Your Welcome Kit
          </div>

          <div className="welcome-login">
            Login?
            <Link to="/login">
              Login here
            </Link>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
}